<template>
  <div class="module bg_white">
    <div class="banner">
      <van-swipe @change="onChange" class="relative">
        <van-swipe-item v-for="(it, idx) in bannerList" :key="idx">
          <div
            class="pic_item bg_contain"
            :style="{
              backgroundImage: `url(${it.url})`
            }"
          >

          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="fs_12 op_0">{{ current + 1 }}/{{ bannerList.length }}</div>
          <div class="underlines d_flex">
            <div
              v-for="i in bannerList.length"
              :key="i"
              class="underline mr_4"
              :class="{ active_line: current + 1 === i }"
            ></div>
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="info">
      <GameItem v-bind="attrs" @go="$emit('go')" />
    </div>
  </div>
</template>

<script>
import GameItem from './GameItem.vue';
export default {
  components: { GameItem },
  props: {
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      current: 0,
    }
  },
  computed: {
    attrs () {
      const { bannerList, ...rest } = this.$attrs
      return rest
    },
  },
  methods: {
    onChange (e) {
      this.current = e
    }
  },
}
</script>

<style lang="scss" scoped>
.module {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: -1px 0px 2px 1px rgba(185,31,8,0.20);
}

.banner {
  border-radius: 8px 8px 0 0 ;
  overflow: hidden;
}
.pic_item {
  border-radius: 8px 8px 0 0 ;
  width: 100%;
  height: 160px;
  background-color: #e5e5e5;
}

.info {
  padding: 10px;
}

.underlines {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
}

.underline {
  width: 16px;
  height: 1px;
  background: #A5A5A5;
}
.active_line {
  background: #FF6A6A;
}
</style>
